export default __webpack_public_path__ + "night-stork-bg-1366x768.eb32806.svg";